import React from "react";
import UrlHelper from "../utilities/UrlHelper";

const SessionTimeoutAlert = () => {
    const inactivity=UrlHelper.parseUrl().query.InactivitySignout;
    const isInactivitySignout = inactivity!=null && inactivity=="1";

    if (isInactivitySignout) {
        return (<div className="validationErrorMessage">
            <div className="validationErrorMessageWrapper validationFailedSubtitle">
                <i className="ion-alert-circled warnValidationCheck"/>
                <div className="validationErrorField">Your session has timed out due to inactivity.</div>
            </div>
        </div>);
    }
    else
        return null;
};

export default SessionTimeoutAlert;
